import { defineStore } from 'pinia'
import store from '@/store'
import { APP_NAMES } from '@/utils/micro-app'

export { APP_NAMES }

interface MicroAppConfigState {
  showMicroApp: boolean
  registeredApps: Set<string>
}

export const useMicroAppConfigStore = defineStore({
  id: 'microAppConfig',
  state: (): MicroAppConfigState => ({
    showMicroApp: false,
    registeredApps: new Set()
  }),
  actions: {
    setMicroAppVisibility(visible: boolean) {
      this.showMicroApp = visible
    },
    isRegisteredApp(app: string) {
      return this.registeredApps.has(app)
    },
    registerApp(app: string) {
      if (!this.registeredApps.has(app)) {
        this.registeredApps.add(app)
      }
    },
    unregisterApp(app: string) {
      this.registeredApps.delete(app)
    }
  }
})

export function useMicroAppConfigStoreWithoutSetup() {
  return useMicroAppConfigStore(store)
}
